var _style, _defs, _defs2, _defs3, _defs4, _defs5, _g, _g2, _defs6, _g3, _g4, _g5, _defs7, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs8, _defs9, _defs10, _defs11, _g17, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167 167",
    style: {
      enableBackground: "new 0 0 167 167"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{clip-path:url(#SVGID_4_);}\n\t.st3{clip-path:url(#SVGID_4_);mask:url(#SVGID_5_);}\n\t.st4{opacity:0.1;clip-path:url(#SVGID_9_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_11_);}\n\t.st7{fill:#939598;}\n\t.st8{fill:#004966;}\n\t.st9{clip-path:url(#SVGID_13_);}\n\t.st10{fill:#ED1C24;}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st12{clip-path:url(#SVGID_15_);}\n\t.st13{clip-path:url(#SVGID_15_);mask:url(#SVGID_16_);}\n\t.st14{opacity:0.35;clip-path:url(#SVGID_20_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.4,
    y: -0.51,
    width: 189.8,
    height: 168.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -0.4,
    y: -0.51,
    width: 189.8,
    height: 168.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -0.51,
    y: -0.54,
    width: 172.32,
    height: 172.32
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.51,
    y: -0.54,
    width: 172.32,
    height: 172.32,
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_6_",
    x: -10.11,
    y: -8.22,
    width: 192,
    height: 182.88
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_7_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 400,
    height: 381,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAVUAAAJcwAADhL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAX8BkgMBIgACEQEDEQH/ xACOAAEBAQADAQEAAAAAAAAAAAAABwYBBAUDAgEBAAAAAAAAAAAAAAAAAAAAABAAAQQBBQACAgMB AAAAAAAAAAM0BhYEEFAiEzYBApAFICESMxEAAQEDDQEAAgMBAQAAAAAAAAFxAgMQIFAxQZEyg6Oz 0wQ0chEhURITYSISAQAAAAAAAAAAAAAAAAAAAJD/2gAMAwEAAhEDEQAAAOv47PmgZ8aBnxoGfGgZ 8aBnxoGfGgZ8aBnxoGfGgZ8aBnxoGfGgZ8aBnxoGfGgZ8aBnxoGfGgZ8aBnxoGfGgZ8aBnxoGfGg Z8aDP6DPnPv+JWTF8VQStVBK1UErVQStVBK1UErVQStVBK1UErVQStVBK1UErVQStVBK1UErVQSt VBK1UErVQStVBK1UEp8C2SM8cAGgz+gz59a3JK2aAAAAAAAAAAAAAAAAAAAAAHWkFfkB44ANBn9B nz61uSVs0AAAAAAAAAAAAAAAAAAAAAOtIK/IDxwAaDP6DPn1rckrZoAAAAAAAAAAAAAAAAAAAAAd aQV+QHjgA0Gf0GfPrW5JWzQAAAAAAAAAAAAAAAAAAAAA60gr8gPHABoM/oM+fWtyStmgAAAAAAAA AAAAAAAAAAAAB1pBX5AeOADQZ/QZ8+tbklbNAAAAAAAAAAAAAAAAAAAAADrSCvyA8cAGgz+gz59a 3JK2aAAAAAAAAAAAAAAAAAAAAAHWkFfkB44ANBn9Bnz61uSVs0AAAAAAAAAAAAAAAAAAAAAOtIK/ IDxwAaDP6DPn1rckrZoAAAAAAAAAAAAAAAAAAAAAdaQV+QHjgA0Gf0GfPrW5JWzQAAAAAAAAAAAA AAAAAAAAA60gr8gPHABoM/oM+fWtyStmgAAAAAAAAAAAAAAAAAAAAB1pBX5AeOADQZ/QZ8+tbklb NAAAAAAAAAAAAAAAAAAAAADrSCvyA8cAGgz+gz59a3JK2aAAAAAAAAAAAAAAAAAAAAAHWkFfkB44 ANBn9Bnz61uSVs0AAAAAAAAAAAAAAAAAAAAAOtIK/IDxwAaDP6DPn1rckrZoAAAAAAAAAAAAAAAA AAAAAdaQV+QHjgA0Gf0GfPrW5JWzQAAAAAAAAAAAAAAAAAAAAA60gr8gPHABoM/oM+fWtyStmgAA AAAAAAAAAAAAAAAAAAB1pBX5AeOADQZ/QZ8+tbklbNAAAAAAAAAAAAAAAAAAAAADrSCvyA8cAGgz +gz59a3JK2aAAAAAAAAAAAAAAAAAAAAAHWkFfkB44ANBn9Bnz61uSVs0AAAAAAAAAAAAAAAAAAAA AOtIK/IDxwAaDP6DPn1rckrZoHA5cDlwOXA5cDlwOXA5cDlwOXA5cDlwOXA5cDlwOXA5cDlwOXA5 cDlwOvIK/IDxwAaDP6DPn63OE5KWmgpaaClpoKWmgpaaClpoKWmgpaaClpoKWmgpaaClpoKWmgpa aClpoKWmgpaaClpoKWmgpaaClpoKPhujwAAf/9oACAECAAEFAPw4f//aAAgBAwABBQD8OH//2gAI AQEAAQUAlstkH66QXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5W XuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7lZe5WXuVl7l Ze5WXuVl7lZe5WXuVl7lZe5WXuVl7lZO/V7lO/Vn0+v+vthRdXJTpixTFimLFMWKYsUxYpixTFim LFMWKYsUxYpixTFimLFMWKYsUxYpixTFimLFMWKYsUxYpixTFimLFMWKYsUxYpixTFimLFMWKYsU xYpixTFimLFMWKYsUxYUh6v0+ubifbFV1nfqzG/7xf6fT5xupM6kzqTOpM6kzqTOpM6kzqTOpM6k zqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTOpM6kzqTO pM6kzqTM9JP4xpL8fHxm6zv1ZiuIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1Zj OIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJ Xus79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOI s22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXu s79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs2 2rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus7 9WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22r PbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus79W YziLNtqz20le6zv1ZjOIs22rPbSV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1ZjOIs22rPb SV7rO/VmM4izbas9tJXus79WYziLNtqz20le6zv1Yl9v8Kfp5QlioXRMuiZdEy6Jl0TLomXRMuiZ dEy6Jl0TLomXRMuiZdEy6Jl0TLomXRMuiZdEy6Jl0TLomXRMuiZdEy6Jl0TLomXRMuiZdEy6Jl0T LomXRMuiZdEy6Jl0TLomZEwSUS/b5f1ysnWd+r0/s5HI5HI5HI5HI5HI5HI5HI5HI5HI5HI5HI5H I5HI5HI5HI5HI5HI5HI5HI5HI5HI/v8Aj//aAAgBAgIGPwAcP//aAAgBAwIGPwAcP//aAAgBAQEG PwDt9Lpdv/Lrwv8AP+jn+cJ78f2hOPr+33FWtT3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMH jPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM9 2jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aM HjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM92jB4z3aMHjPdoweM 92jB4z3aMHjPdoweM72Tsw6T72Tsw5EdS39CP/tfz/BU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPF TxU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPFTxU8VPFTwr34e/R/m9M7 2Tsw5If0gn5RF/RhQwoYUMKGFDChhQwoYUMKGFDChhQwoYUMKGFDChhQwoYUMKGFDChhQwoYUMKG FDChhQwoYUMKGFDChhQwoYUMKGFDCg9/5So/X/ZneydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7 J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+ kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+w vmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydm HJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBG UW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5n eydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ /pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFv sL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3sn ZhyQ/pBGUW+wvmd7J2YckP6QRlFvsL5neydmHJD+kEZRb7C+Z3snZhyQ/pBGUW+wvmd7J2YckP6Q RlFvsL5neydmHI69/C/kR3+yJ+qlUxJeYkvMSXmJLzEl5iS8xJeYkvMSXmJLzEl5iS8xJeYkvMSX mJLzEl5iS8xJeYkvMSXmJLzEl5iS8xJeYkvMSXmJLzEl5iS8xJeYkvMSXmJLzEl5iS8xJeYkvMSX mJLzEl5iS8ed/sn7T+T+7v7T+ZneydmHMtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS 0tLS0tLS0tLS2d//2Q==",
    transform: "matrix(0.48 0 0 0.48 -10.1113 -8.2223)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_8_",
    x: -0.51,
    y: -0.54,
    width: 172.32,
    height: 172.32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.51,
    y: -0.54,
    width: 172.32,
    height: 172.32
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.28,
    y: -0.39,
    className: "st5",
    width: 167.77,
    height: 167.78
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_10_",
    x: -0.4,
    y: -0.51,
    width: 189.8,
    height: 168.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.62,167.51H-0.4V-0.51h168.02V167.51z M-0.15,167.26h167.52V-0.26H-0.15V167.26z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15.23,39.88h14.65V26.59H35v33.96h-5.12V44.69H15.23v15.86H10.1V26.59h5.12V39.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.32,39.13h4.97v21.42h-4.97v-2.24c-2.04,1.91-4.23,2.86-6.58,2.86c-2.96,0-5.41-1.07-7.35-3.21 c-1.92-2.18-2.88-4.91-2.88-8.18c0-3.21,0.96-5.89,2.88-8.03c1.92-2.14,4.33-3.21,7.21-3.21c2.49,0,4.73,1.03,6.71,3.08V39.13z  M43.58,49.77c0,2.05,0.55,3.72,1.65,5.01c1.13,1.31,2.55,1.96,4.27,1.96c1.83,0,3.31-0.63,4.44-1.89 c1.13-1.3,1.69-2.96,1.69-4.97s-0.56-3.67-1.69-4.97c-1.13-1.28-2.6-1.91-4.4-1.91c-1.7,0-3.12,0.65-4.27,1.94 C44.14,46.24,43.58,47.85,43.58,49.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M84.29,51H68.94c0.13,1.76,0.7,3.16,1.72,4.2c1.01,1.03,2.31,1.54,3.89,1.54c1.23,0,2.25-0.29,3.06-0.88 c0.79-0.59,1.69-1.67,2.71-3.25l4.18,2.33c-0.65,1.1-1.33,2.04-2.05,2.83c-0.72,0.78-1.49,1.43-2.31,1.94 c-0.82,0.51-1.71,0.88-2.66,1.11s-1.99,0.35-3.1,0.35c-3.2,0-5.76-1.03-7.7-3.08c-1.94-2.07-2.9-4.81-2.9-8.23 c0-3.39,0.94-6.13,2.82-8.23c1.89-2.07,4.4-3.1,7.52-3.1c3.15,0,5.65,1,7.48,3.01c1.82,1.99,2.73,4.76,2.73,8.29L84.29,51z  M79.21,46.96C78.52,44.32,76.86,43,74.22,43c-0.6,0-1.17,0.09-1.69,0.27c-0.53,0.18-1.01,0.45-1.44,0.79 c-0.43,0.34-0.8,0.76-1.11,1.24c-0.31,0.48-0.54,1.03-0.7,1.65H79.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.35,39.13h4.97v1.98c1.73-1.72,3.68-2.57,5.85-2.57c2.49,0,4.43,0.78,5.83,2.35 c1.2,1.33,1.8,3.51,1.8,6.53v13.13h-4.97V48.58c0-2.11-0.29-3.57-0.88-4.38c-0.57-0.82-1.61-1.23-3.12-1.23 c-1.64,0-2.81,0.54-3.5,1.63c-0.67,1.07-1.01,2.94-1.01,5.61v10.34h-4.97V39.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.7,42.78l-4.09,2.18c-0.64-1.32-1.44-1.98-2.4-1.98c-0.46,0-0.84,0.15-1.17,0.45s-0.48,0.69-0.48,1.15 c0,0.82,0.95,1.64,2.86,2.44c2.62,1.13,4.39,2.17,5.3,3.12c0.91,0.95,1.36,2.24,1.36,3.85c0,2.07-0.76,3.8-2.29,5.19 c-1.48,1.32-3.27,1.98-5.37,1.98c-3.59,0-6.14-1.75-7.63-5.26l4.22-1.96c0.59,1.03,1.03,1.68,1.34,1.96 c0.6,0.56,1.32,0.84,2.16,0.84c1.67,0,2.51-0.76,2.51-2.29c0-0.88-0.64-1.7-1.94-2.46c-0.5-0.25-1-0.49-1.5-0.73 c-0.5-0.23-1-0.48-1.52-0.73c-1.44-0.7-2.45-1.41-3.04-2.11c-0.75-0.89-1.12-2.05-1.12-3.45c0-1.86,0.64-3.4,1.91-4.62 c1.3-1.22,2.89-1.83,4.75-1.83C120.32,38.53,122.36,39.95,123.7,42.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.18,51h-15.35c0.13,1.76,0.7,3.16,1.72,4.2c1.01,1.03,2.31,1.54,3.89,1.54c1.23,0,2.25-0.29,3.06-0.88 c0.79-0.59,1.69-1.67,2.71-3.25l4.18,2.33c-0.65,1.1-1.33,2.04-2.05,2.83s-1.49,1.43-2.31,1.94s-1.71,0.88-2.66,1.11 s-1.99,0.35-3.1,0.35c-3.2,0-5.76-1.03-7.7-3.08c-1.94-2.07-2.9-4.81-2.9-8.23c0-3.39,0.94-6.13,2.82-8.23 c1.89-2.07,4.4-3.1,7.52-3.1c3.15,0,5.65,1,7.48,3.01c1.82,1.99,2.73,4.76,2.73,8.29L148.18,51z M143.1,46.96 c-0.69-2.64-2.35-3.96-4.99-3.96c-0.6,0-1.17,0.09-1.69,0.27c-0.53,0.18-1.01,0.45-1.44,0.79c-0.43,0.34-0.8,0.76-1.11,1.24 c-0.31,0.48-0.54,1.03-0.7,1.65H143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.19,23.4v37.15h-4.95V23.4H157.19z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.44,97.47H64.77l-3.82,8.33h-5.57l16.97-36.44l16.37,36.44h-5.66L79.44,97.47z M77.34,92.6l-5.09-11.66 L66.92,92.6H77.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M92.66,105.79l7.22-36.86l11.77,26.65l12.19-26.65l6.48,36.86h-5.31l-3.31-20.7l-10.15,22.27l-9.86-22.3 l-3.69,20.72H92.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.51,76.61l-4.2,2.49c-0.79-1.36-1.53-2.25-2.24-2.66c-0.74-0.47-1.7-0.71-2.86-0.71 c-1.44,0-2.63,0.41-3.58,1.22c-0.95,0.8-1.42,1.81-1.42,3.02c0,1.67,1.24,3.02,3.73,4.04l3.42,1.4c2.78,1.12,4.82,2.5,6.11,4.12 s1.93,3.61,1.93,5.96c0,3.15-1.05,5.76-3.15,7.82c-2.12,2.07-4.75,3.11-7.88,3.11c-2.98,0-5.43-0.88-7.37-2.64 c-1.91-1.76-3.1-4.24-3.58-7.44l5.24-1.16c0.24,2.01,0.65,3.41,1.24,4.17c1.07,1.48,2.62,2.22,4.66,2.22 c1.61,0,2.95-0.54,4.02-1.62c1.07-1.08,1.6-2.45,1.6-4.11c0-0.67-0.09-1.28-0.28-1.83c-0.18-0.55-0.47-1.07-0.87-1.53 c-0.39-0.47-0.9-0.9-1.52-1.31c-0.62-0.41-1.36-0.8-2.22-1.17l-3.31-1.38c-4.69-1.98-7.04-4.89-7.04-8.71 c0-2.58,0.98-4.73,2.95-6.46c1.97-1.75,4.42-2.62,7.35-2.62C151.21,70.84,154.29,72.77,156.51,76.61z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_12_",
    x: -0.4,
    y: -0.51,
    width: 189.8,
    height: 168.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M25.01,81.75c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 V83.2c0-0.8-0.65-1.45-1.45-1.45H25.01z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.8,81.75c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 V83.2c0-0.8-0.65-1.45-1.45-1.45H10.8z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24.96,95.53c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H24.96z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M25.01,68.01c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H25.01z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.8,68.01c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H10.8z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M39.31,68.01c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H39.31z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M39.31,81.75c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 V83.2c0-0.8-0.65-1.45-1.45-1.45H39.31z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.75,95.53c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H10.75z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M39.27,95.53c-0.8,0-1.45,0.65-1.45,1.45v7.55c0,0.8,0.65,1.45,1.45,1.45h7.55c0.8,0,1.45-0.65,1.45-1.45 v-7.55c0-0.8-0.65-1.45-1.45-1.45H39.27z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.07,
    y: 117.26,
    className: "st5",
    width: 157.06,
    height: 1.31
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,145.58l2.91-17.15h4.41l3.43,9.14l3.41-9.14h4.41l2.91,17.15h-4.43l-1.48-9.87l-4.05,9.87h-1.77l-3.84-9.87 l-1.48,9.87H25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,133.91h4.14v11.67H56.2v-1.3c-0.88,1.11-2.07,1.66-3.57,1.66c-0.85,0-1.63-0.16-2.34-0.47 c-0.71-0.31-1.33-0.75-1.86-1.31c-0.53-0.56-0.94-1.22-1.24-1.98c-0.3-0.76-0.44-1.58-0.44-2.48c0-0.83,0.14-1.63,0.43-2.38 c0.29-0.75,0.69-1.41,1.21-1.97c0.52-0.56,1.13-1,1.84-1.33c0.71-0.33,1.5-0.49,2.37-0.49c1.46,0,2.66,0.51,3.62,1.52V133.91z  M51.01,139.71c0,0.38,0.07,0.73,0.21,1.06c0.14,0.33,0.32,0.61,0.56,0.85c0.23,0.24,0.52,0.43,0.84,0.57 c0.33,0.14,0.68,0.21,1.06,0.21c0.36,0,0.71-0.07,1.03-0.21c0.33-0.14,0.61-0.33,0.84-0.57c0.23-0.24,0.42-0.52,0.57-0.84 c0.14-0.32,0.22-0.66,0.22-1.02c0-0.36-0.07-0.71-0.22-1.04c-0.14-0.33-0.33-0.61-0.57-0.85c-0.24-0.24-0.52-0.43-0.84-0.57 s-0.67-0.21-1.03-0.21c-0.38,0-0.73,0.07-1.06,0.21c-0.33,0.14-0.61,0.33-0.84,0.57c-0.24,0.24-0.42,0.52-0.56,0.83 C51.08,139.01,51.01,139.34,51.01,139.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.07,137.34v8.23h-4.12v-8.23h-1.36v-3.43h1.36v-3.5h4.12v3.5h2.34v3.43H67.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.52,126.7h4.12v8.69c0.56-0.68,1.13-1.14,1.71-1.38c0.58-0.23,1.25-0.35,2.02-0.35c1.47,0,2.58,0.41,3.33,1.22 c0.75,0.81,1.13,1.91,1.13,3.29v7.41h-4.12v-5.89c0-0.59-0.05-1.07-0.14-1.43s-0.24-0.64-0.46-0.84c-0.36-0.32-0.8-0.48-1.32-0.48 c-0.7,0-1.23,0.21-1.6,0.63c-0.37,0.42-0.56,1.01-0.56,1.79v6.23h-4.12V126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,145.58H84.9v-17.15h7.1c1.92,0,3.4,0.5,4.42,1.5c1.02,1,1.53,2.41,1.53,4.23c0,1.82-0.51,3.23-1.53,4.23 c-1.02,1-2.5,1.5-4.42,1.5h-2.64V145.58z M89.35,136.3h1.48c1.64,0,2.46-0.71,2.46-2.14c0-1.42-0.82-2.14-2.46-2.14h-1.48V136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,140.44c0,1.77,0.83,2.66,2.5,2.66c0.89,0,1.57-0.36,2.02-1.09h3.98c-0.8,2.67-2.81,4-6.03,4 c-0.99,0-1.89-0.15-2.71-0.44c-0.82-0.29-1.52-0.72-2.1-1.26s-1.03-1.2-1.35-1.96c-0.32-0.76-0.48-1.61-0.48-2.55 c0-0.97,0.15-1.84,0.45-2.63c0.3-0.78,0.74-1.44,1.3-1.99c0.56-0.55,1.24-0.97,2.04-1.26s1.69-0.44,2.69-0.44 c0.99,0,1.87,0.15,2.66,0.44c0.79,0.3,1.46,0.72,2,1.29s0.96,1.25,1.25,2.06c0.29,0.81,0.43,1.72,0.43,2.74v0.43H101.81z  M106.64,138.05c-0.14-0.58-0.42-1.04-0.84-1.39s-0.94-0.52-1.55-0.52c-0.64,0-1.16,0.17-1.56,0.5c-0.4,0.33-0.66,0.8-0.76,1.41 H106.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,139.64c0-0.86,0.17-1.67,0.52-2.42c0.35-0.75,0.83-1.4,1.46-1.96c0.62-0.55,1.36-0.99,2.22-1.31 s1.79-0.48,2.81-0.48c1,0,1.93,0.16,2.79,0.47c0.86,0.31,1.6,0.74,2.23,1.3c0.63,0.55,1.12,1.21,1.47,1.98 c0.35,0.77,0.52,1.61,0.52,2.54s-0.18,1.77-0.53,2.54s-0.84,1.43-1.47,1.98c-0.62,0.55-1.37,0.98-2.24,1.29 c-0.87,0.3-1.82,0.45-2.83,0.45c-1,0-1.92-0.15-2.77-0.45c-0.85-0.3-1.58-0.74-2.2-1.3c-0.61-0.56-1.09-1.23-1.44-2.01 C111.43,141.46,111.25,140.59,111.25,139.64z M115.59,139.69c0,0.39,0.07,0.75,0.22,1.08c0.14,0.33,0.33,0.61,0.57,0.85 c0.24,0.24,0.52,0.43,0.84,0.57c0.33,0.14,0.67,0.21,1.03,0.21c0.36,0,0.71-0.07,1.04-0.21c0.33-0.14,0.61-0.33,0.84-0.57 c0.24-0.24,0.42-0.53,0.57-0.85c0.14-0.33,0.22-0.68,0.22-1.06c0-0.36-0.07-0.71-0.22-1.03c-0.14-0.33-0.33-0.61-0.57-0.85 c-0.23-0.24-0.52-0.43-0.84-0.57c-0.33-0.14-0.67-0.2-1.04-0.2c-0.36,0-0.71,0.07-1.03,0.2c-0.33,0.14-0.61,0.33-0.84,0.57 c-0.24,0.24-0.42,0.52-0.57,0.84C115.67,138.98,115.59,139.32,115.59,139.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.63,151.4h-4.12v-17.49h4.12v1.3c0.88-1.11,2.08-1.66,3.59-1.66c0.83,0,1.61,0.16,2.33,0.49 c0.72,0.33,1.34,0.77,1.88,1.33c0.53,0.56,0.94,1.22,1.24,1.98c0.3,0.76,0.44,1.57,0.44,2.43s-0.15,1.67-0.44,2.41 c-0.3,0.74-0.71,1.4-1.23,1.96c-0.52,0.56-1.14,1-1.85,1.32c-0.71,0.32-1.49,0.48-2.32,0.48c-1.46,0-2.67-0.5-3.64-1.5V151.4z  M135.81,139.78c0-0.36-0.06-0.71-0.19-1.03s-0.31-0.61-0.56-0.85c-0.24-0.24-0.53-0.44-0.85-0.58c-0.33-0.14-0.68-0.22-1.06-0.22 c-0.36,0-0.7,0.07-1.02,0.21s-0.6,0.33-0.83,0.57c-0.24,0.24-0.42,0.53-0.57,0.85c-0.14,0.33-0.22,0.67-0.22,1.04 c0,0.36,0.07,0.71,0.21,1.02s0.33,0.59,0.57,0.83c0.24,0.23,0.53,0.42,0.85,0.57c0.33,0.14,0.67,0.22,1.04,0.22 c0.36,0,0.71-0.07,1.02-0.21c0.32-0.14,0.59-0.33,0.83-0.57c0.23-0.24,0.42-0.52,0.57-0.84 C135.74,140.46,135.81,140.12,135.81,139.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2,126.7v18.87h-4.12V126.7H145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.39,140.44c0,1.77,0.83,2.66,2.5,2.66c0.89,0,1.57-0.36,2.02-1.09h3.98c-0.8,2.67-2.81,4-6.03,4 c-0.99,0-1.89-0.15-2.71-0.44c-0.82-0.29-1.52-0.72-2.1-1.26c-0.58-0.55-1.04-1.2-1.35-1.96c-0.32-0.76-0.48-1.61-0.48-2.55 c0-0.97,0.15-1.84,0.46-2.63c0.3-0.78,0.74-1.44,1.3-1.99s1.24-0.97,2.04-1.26s1.69-0.44,2.7-0.44c0.99,0,1.87,0.15,2.66,0.44 s1.46,0.72,2,1.29s0.96,1.25,1.25,2.06c0.29,0.81,0.43,1.72,0.43,2.74v0.43H150.39z M155.21,138.05 c-0.14-0.58-0.42-1.04-0.84-1.39c-0.42-0.35-0.94-0.52-1.55-0.52c-0.64,0-1.16,0.17-1.56,0.5c-0.4,0.33-0.66,0.8-0.76,1.41H155.21 z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_14_",
    x: -0.4,
    y: -0.51,
    width: 189.8,
    height: 168.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 7.8,
    y: 127.14,
    width: 16.32,
    height: 18.72
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.8,
    y: 127.14,
    width: 16.32,
    height: 18.72,
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -1.32,
    y: 110.82,
    width: 71.04,
    height: 46.08
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_18_)"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 148,
    height: 96,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAIPAAAC+QAABK3/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGIAlgMBIgACEQEDEQH/ xACJAAEBAQEBAQEAAAAAAAAAAAAABgcDBAUCAQEAAAAAAAAAAAAAAAAAAAAAEAAABQQDAQEAAAAA AAAAAAAAAwQFBgIWNgcwQAEQYBEAAQIDBgYBAwUAAAAAAAAAAQIDABEEIXKjs9M0EDBAMRITFEFR YYHBIkIFEgEAAAAAAAAAAAAAAAAAAABg/9oADAMBAAIRAxEAAADl8TpNlAnxQJ8UCfFAnxQJ8UCf FAnxQJ8UCfFJN0k2AAAAAAAAAUk3STY7cqc4cNM5mVeKqlQAAAAACkm6SbP3ruX6+PXw9JGZtoGf gAAAAAFJN0k2frTsv+wV1Lk3pPl8AAAAAAApJukmwAAAAAAAACkmwAAAAAAAAA//2gAIAQIAAQUA /Df/2gAIAQMAAQUA/Df/2gAIAQEAAQUAmErf2x+vuVi+5WL7lYvuVi+5WL7lYvuVi+5WL7lYvuVi +5WL7lYvuVi+5WL7lYvuVi+5WL7lY2BlHS2BlHS2BlHS2BlHxKmMVqFcJeUaZribq6p3RqUtSnk2 BlA889q9izC50vEsLUGssORGomWaIHI515NgZQCavKDY7JG9ypd3tG0UEqKDk8lmDSpbuTYGUBiJ KPdW5na0NS9ub1wpKKoJnTS1pEHJsDKBRXWXVrz081ukSk82VyE/1MynrVR/nJsDKPjdKXhsTmP7 kY4rpe9r0/LsDKOlsDKOlsDKOl//2gAIAQICBj8ADf/aAAgBAwIGPwAN/9oACAEBAQY/AH6OhqvV ToS2Uo9bSpFSAo2rQT3jfYLOnG+wWdON9gs6cb7BZ0432CzpxvsFnTjfYLOnG+wWdON9gs6cb7BZ 0432CzpxvsFnTjfYLOnG+wWdON9gs6cb7BZ0432CzpxvsFnTipuNZaejqbjWWno6m41lp6OpuNZa eLdO0JrcMkwupeSkNtiZM4+RSpBbnK0x8aqkHAJkDm1NxrLTwAFpNgEUzz9MtDIt8yLIeZp0Kccc HiEptMNNPoLbv9knvD9X8dfx0WeyVkhzam41lp4IWeyVAn9DCKOm8i42geRIsshC6qcnD4pl94TU JmEKT5Cf2iqoGyr3EFEpfUc2puNZaeFO08AptSv5A9oLlE0lCyLSkwhNYhK/AzQCZWx6gJNgSl+I D1K2lLqlTUoGZ5tTcay08AtCilQ7EWGHH31qWpSpAqM7Io6VtxSUpIK0gyBH5iocBkUosMeLzq1p nMBRJHNqbjWWniKekcShsWyInA/0luA1SRIKlZCqaodCml2EAS/fnVNxrLT0dTcay09HU3GstPR/ /9k=",
    transform: "matrix(0.48 0 0 0.48 -1.3189 110.8211)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 7.8,
    y: 127.14,
    width: 16.32,
    height: 18.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 127.14,
    width: 16.32,
    height: 18.72
  })))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.81,137.59v2.99h-2.76l-0.62,4.76h-3.43l0.62-4.76H14.4l-0.62,4.76h-3.4l0.64-4.76H8.62v-2.99h2.76l0.28-2.21H9.31 v-2.97h2.74l0.58-4.42h3.38l-0.57,4.42h2.23l0.6-4.42h3.4l-0.58,4.42h2.35v2.97h-2.71l-0.3,2.21H22.81z M17.29,135.38h-2.23 l-0.3,2.21H17L17.29,135.38z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/square-logo.979902ad.svg";
export { ForwardRef as ReactComponent };